export const offer = {
  productName: "Método de Cenas Antiinflamatorias en 15 Minutos",
  regularPrice: "$155.00 USD",
  totalValue: "$155 USD",
  price: "$15.90",
  currency: "USD",
};

export const priceStack = [
  { item: "Guía Maestra Anti-Inflamatoria", value: "$53 USD" },
  { item: "Recetario Maestro 21 Cenas", value: "$31 USD" },
  { item: "Checklist Despensa", value: "$19 USD" },
  { item: "Planificador Semanal", value: "$14 USD" },
  { item: "Guía de Infusiones", value: "$19 USD" },
  { item: "Ritual de Cierre 30 Minutos", value: "$19 USD" },
];

export const dinnerQualities = [
  "Calientes",
  "Simples",
  "Saciantes",
  "Fáciles de digerir",
  "Listas en 15 minutos",
  "Pensadas para acompañar el descanso",
];

export const loadingChecks = [
  "Tu tipo de hinchazón",
  "Tu relación con la cena",
  "Tu nivel de digestión nocturna",
  "Tus posibles detonantes",
  "Qué cambio tendría más sentido empezar esta noche",
];

export const loadingPhases = [
  "Identificando patrón digestivo…",
  "Cruzando respuestas con rutina nocturna…",
  "Generando recomendación personalizada…",
];
